import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import ArticleGraphic from "./SectionOne.png";


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <h3
                                className={
                                    styles.title +
                                    " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt pb-10"
                                }
                                >
                                    Manage Passwords Easily with EngineID
                                </h3>
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <img alt="EngineID App Launch" className={styles.tabletImage} src={ArticleGraphic} />
                                        <p>
                                            The secure management of corporate passwords is a constant struggle for businesses of all sizes. Password management without a strategy exposes your business data to unnecessary risk.
                                        </p>
                                        <p>
                                            Introducing Passwords Management in EngineID and how to reduce your security risk.
                                        </p>
                                        <p>
                                            In the Password Management module, a ‘Password’ is a password, passphrase or any other private credential you use to sign onto a website or system. EngineID provides a user friendly interface to store passwords safely within your EngineID account.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}